import React from 'react'
import { Link } from 'react-router-dom'

const MobileItem = ({Obj}) => {
  return (
    <Link to={'view/'+Obj.id}>
        <div className='mobile_order_container'>
            <h3>{Obj.orderno}</h3>
            <div className='mobile_order_sections'>
                <div className='mobile_order_section'>
                    <div className='mobile_order_item'>
                        <h5>Fulfilment Status</h5>
                        <p>{Obj.fulfilmentstatus==0?"Unfulfilled":"Fulfilled"}</p>
                    </div>
                    <div className='mobile_order_item'>
                        <h5>Payment Status</h5>
                        <p>{Obj.paymentstatus==0?"Unpaid":"Paid"}</p>
                    </div>
                    <div className='mobile_order_item'>
                        <h5>Total</h5>
                        <p>{Obj.total}</p>
                    </div>
                </div>
                <div className='mobile_order_section'>
                    <div className='mobile_order_item'>
                        <h5>Commission</h5>
                        <p>{Obj.commission}</p>
                    </div>
                    <div className='mobile_order_item'>
                        <h5>Seller Shipping</h5>
                        <p>{Obj.sellershipping}</p>
                    </div>
                    <div className='mobile_order_item'>
                        <h5>Seller Payables</h5>
                        <p>{Obj.sellerpayables}</p>
                    </div>
                </div>
            </div>
        </div>
    </Link>
  )
}

export default MobileItem
